import script from "./index.vue?vue&type=script&lang=ts&name=Course&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&name=Course&setup=true"

import "./index.vue?vue&type=style&index=0&id=913b2fee&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-913b2fee"]])

export default __exports__